export const ResultsModalView = Object.freeze({
  CHOICE: 'choice',
  GROUP: 'group',
  SPORTER: 'sporter',
  SESSION: 'session'
});
